module.exports = __webpack_public_path__ + "static/media/varejo-subheader.4b5d36e1.jpg";